export function createJournalMentionConfig({ tags, templates }) {
    const tagConfig = createTagMentionConfig({
        tags,
        marker: '#',
    });

    const templateConfig = createTemplateMentionConfig({
        templates,
        marker: '+',
    });

    return combineMentionConfigs([tagConfig, templateConfig]);
}


function createTagMentionConfig({ tags, marker = '#' }) {
    const items = buildTagItems({ tags });

    return {
        items,
        feed: {
            marker,
            feed: createMentionFeed(items)
        },
        handler: {
            tag: 'insertTags',
        },
    };
}

function createTemplateMentionConfig({ templates, marker = '+' }) {
    const items = buildTemplateItems({ templates });

    return {
        items,
        feed: {
            marker,
            feed: createMentionFeed(items)
        },
        handler: {
            template: 'insertTemplates',
        },
    };
}

function combineMentionConfigs(configs = []) {
    const allItems = configs.flatMap(c => c.items || []);

    const allFeeds = configs.map(c => c.feed).filter(Boolean);

    const allHandlers = {};

    configs.forEach(c => {
        if (c.handler) {
            Object.assign(allHandlers, c.handler);
        }
    });
    
    return {
        items: allItems,
        feeds: allFeeds,
        handlers: allHandlers,
    };
}


function buildTagItems({ tags = [] }) {
    return tags
        .filter(t => t?.keyword)
        .map(t => ({
            keyword: t.keyword,
            name: t.name,
            type: 'tag',
            payload: t,
        }));
}

function buildTemplateItems({ templates = [] }) {
    return templates
        .filter(t => t?.keyword)
        .map(t => ({
            keyword: t.keyword,
            name: t.title,
            type: 'template',
            payload: t,
        }));
}

function createMentionFeed(items) {
    return (queryText = '') => {
        const q = queryText.toLowerCase();
        return items
            .filter(i => !q || i.keyword?.toLowerCase()?.includes(q))
            .map(i => ({ id: i.keyword, name: i.name, payload: i.payload }));
    };
}
